import React, { PureComponent } from "react";
import { connect } from "react-redux";
import {
  setCurrentNavPage,
  setSubMenuDirection,
  setSubMenuDirectionToggle
} from "Actions";
// import CollaboratorClientsFolders from "./clientsFolders";
import { HORIZONTAL, VERTICAL } from "Config";
import ClientsFolders from "./CollaboratorClientsFolders";

class CollaboratorClientsFoldersPage extends PureComponent {
  constructor(props) {
    super(props);
    let { uen } = this.props.match.params;

    this.state = { organizationUen: uen };
  }

  componentDidMount() {
    const { dispatch, subMenuDirection } = this.props;

    dispatch(setCurrentNavPage("FOLDERS"));

    if (subMenuDirection === VERTICAL) {
      dispatch(setSubMenuDirection(HORIZONTAL));
    }
    dispatch(setSubMenuDirectionToggle(true));

    let { uen } = this.props.match.params;
    this.setState({ organizationUen: uen });
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(setSubMenuDirectionToggle(true));
  }

  render() {
    return (
      <div className={`page-content`} style={{ display: "contents" }}>
        <ClientsFolders />
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  organization: state.timeSheet.organization,
  currentOrganization: state.auth.currentOrganization
});

export default connect(mapStateToProps)(CollaboratorClientsFoldersPage);



// WEBPACK FOOTER //
// ./src/components/CollaboratorClientsFolders/CollaboratorClientsFoldersPage.js